// Source-access dates describe evidence checks; editorial dates do not.
export function getSourceCheckRange(sources) {
  const dates = [...new Set(sources.map((source) => source.accessed))].sort();
  if (!dates.length) return null;
  for (const date of dates) {
    if (typeof date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(date)
      || Number.isNaN(Date.parse(`${date}T00:00:00Z`))
      || new Date(`${date}T00:00:00Z`).toISOString().slice(0, 10) !== date) {
      throw new Error(`Invalid research source access date: ${date}`);
    }
  }
  return { start: dates[0], end: dates.at(-1) };
}
